export class UpdateTaskDueDate
{
    public dueDate: Date;
    public reasonReschedule: string;
}
